<template>
    <div class="fSize">
        <van-empty v-show="emptyShow" :description="content"/>
        <van-cell class="newCell" v-for="item in list">
            <van-field label-width="100%" class="newTitle" :label="item.title" readonly/>
            <van-field label-width="18%" class="newField" :border="false" left-icon="clock-o"
                       label="营业时间：" :value="item.businessDate" autosize readonly/>
            <van-field label-width="18%" class="newField" :border="false" left-icon="underway-o"
                       label="体检时间：" :value="item.physicalDate" autosize readonly/>
            <van-field label-width="18%" class="newField" :border="false" left-icon="description"
                       label="领取报告：" :value="item.drawReport" autosize readonly/>
            <van-field label-width="18%" class="newField" :border="false" left-icon="location-o"
                       label="体检地址：" :value="item.physicalAddress" autosize readonly/>
        </van-cell>
    </div>
</template>
<script>
    //引用vant组件，用什么引什么
    import {gainBranchInformation} from "@/api/common";
    import {Toast, Empty, Cell, Field} from "vant";

    export default {
        components: {
            [Toast.name]: Toast,
            [Cell.name]: Cell,
            [Empty.name]: Empty,
            [Field.name]: Field
        },
        data() {
            return {
                //-------
                content: "数据请求中...",
                emptyShow: true,
                list: []
            };
        },
        created() {
            const that = this;
            //---控制头尾显示与隐藏----
            //that.$emit('footer', true);
            //this.$emit('header', false);
            that.gainInfo();
        },
        mounted() {
            window.history.pushState(null, null, "#");
            window.addEventListener(
                "popstate",
                function (e) {
                    WeixinJSBridge.call("closeWindow");
                },
                false
            );
        },
        methods: {
            gainInfo: function (code) {
                const that = this;
                gainBranchInformation({openId: sessionStorage.getItem("openid")}).then(resp => {
                    if (resp.code === 200) {
                        that.list = resp.data;
                        if (resp.data.length === 0) {
                            that.content = "暂无信息...";
                        } else {
                            that.emptyShow = false;
                        }
                    } else {
                        that.emptyShow = true;
                        that.content = resp.msg;
                    }
                }).catch(err => {
                    console.log(err);
                });
            }
        }
    };
</script>
<style scoped lang="scss">
    .newCell {
        margin: 0.12rem;
        width: initial;
        padding: 0.12rem;
        box-shadow: gray 0 0 0.15rem;
        border-radius: 0.1rem;

        .newTitle {
            width: initial;
            padding: 0.12rem;
            font-size: 0.28rem;
            font-weight: 700;
        }

        .newField {
            padding: 0.12rem;
            font-size: 0.24rem;
            line-height: 0.4rem;
            border-bottom: 0.01rem #f0f0f0 solid;
        }
    }
</style>
